Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles(_ref) {
  var isCentred = _ref.isCentred;
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    bp = _STYLES$useStyles.bp;
  var container = {
    maxWidth: _styles.STYLES.grid.maxCardWidth,
    minHeight: (0, _styles.getREM)(14)
  };
  var categoryPills = {};
  if (isCentred || bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal, bp.mobile_m])) {
    categoryPills.justifyContent = 'center';
    categoryPills.width = '100%';
  }
  var styles = _reactNative.StyleSheet.create({
    container: container,
    categoryPills: categoryPills
  });
  return {
    styles: styles
  };
};